import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import MenuSection from '../components/MenuSection';
import MenusExtras from '../components/MenusExtras';
import ContactInfo from '../components/ContactInfo';
import Footer from '../components/Footer';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <MenuSection />
      <MenusExtras />
      <ContactInfo />
      <Footer />
    </div>
  );
};

export default HomePage;